var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"icon__flag",attrs:{"width":"15","height":"20","viewBox":"0 0 15 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M15 10L12.5 5.625L15 1.25H3.75C3.75 0.559693 3.19031 0 2.5 0C1.80969 0 1.25 0.559693 1.25 1.25V17.5H0V20H5V17.5H3.75V10H15Z","fill":"#000"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }